// extracted by mini-css-extract-plugin
export default {"loader":"T-dkX","ellipse":"yFH--","percentage":"_3d5RE","skeleton-progress":"-wRms"};